import { Injectable } from '@angular/core';

declare const $: any;

export interface ModalOptions {
    backdrop?: 'static' | boolean;
    keyboard?: boolean;
    show?: boolean;
}

/**
 * Modal service to manage Bootstrap 3 modals using jQuery
 * This service provides methods to open and close modals programmatically
 */
@Injectable({
    providedIn: 'root'
})
export class ModalService {
    /**
     * Opens a modal by its ID
     * @param modalId The ID of the modal element
     * @param options Optional configuration for the modal
     */
    open(modalId: string, options?: ModalOptions): void {
        const defaultOptions: ModalOptions = {
            backdrop: 'static',
            keyboard: false,
            show: true
        };

        const modalOptions = { ...defaultOptions, ...options };
        $(`#${modalId}`).modal(modalOptions);
    }

    /**
     * Closes a modal by its ID
     * @param modalId The ID of the modal element
     */
    close(modalId: string): void {
        $(`#${modalId}`).modal('hide');
    }

    /**
     * Toggles a modal by its ID
     * @param modalId The ID of the modal element
     */
    toggle(modalId: string): void {
        $(`#${modalId}`).modal('toggle');
    }

    /**
     * Check if a modal is currently visible
     * @param modalId The ID of the modal element
     * @returns true if modal is visible
     */
    isOpen(modalId: string): boolean {
        return $(`#${modalId}`).hasClass('in');
    }
}
